import {
  CALENDAR_DEFAULT_TASK_STATUSES,
  LIST_DEFAULT_TASK_STATUSES,
} from "components/Tasks/taskStatusFilter";

import { TaskFilterType } from "./TaskFilterChips";

/**
 * Returns the default omnisearch string for the tasks page. URL `omnisearch`
 * values override keys via OmnisearchDataDisplay's smart merge.
 */
export function getDefaultTaskSearch(
  tenantId: string | undefined,
  activeFilter: TaskFilterType | null
): string {
  const base = `tenantId:${tenantId}`;

  switch (activeFilter) {
    case TaskFilterType.Overdue:
      return `${base} status:OVERDUE`;
    case TaskFilterType.Completed:
      return `${base} taskStatus:COMPLETED`;
    case TaskFilterType.AllButCanceled:
      return `${base} taskStatus:${CALENDAR_DEFAULT_TASK_STATUSES}`;
    case TaskFilterType.Open:
    default:
      return `${base} taskStatus:${LIST_DEFAULT_TASK_STATUSES}`;
  }
}
